// deno-fmt-ignore-file
import { Tuple } from '../../types/tuple.mjs';
import { Immutable } from '../../types/_immutable.mjs';
export function FromTuple(types) {
    const result = Immutable(Tuple(types));
    return result;
}
